import {createSlice, createSelector} from '@reduxjs/toolkit';
import {accountsApi, UserInfo} from '../services/accounts';
import {companiesApi} from '../services/companies';
import {removeAccessToken, storeAccessToken} from '../cookies';
import {RootState} from '../store';

export interface AuthState {
	user: UserInfo | null;
	token: string | null;
	isIntroDialogOpen: boolean;
	isAccountDialogOpen: boolean;
}

const initialState: AuthState = {
	user: null,
	token: null,
	isIntroDialogOpen: false,
	isAccountDialogOpen: false,
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		tokenSetState(state, action) {
			state.token = action.payload;
			return state;
		},
		resetState() {
			removeAccessToken();
			return initialState;
		},
		isIntroDialogOpenSetState(state, action) {
			state.isIntroDialogOpen = action.payload;
		},
		isAccountDialogOpenSetState(state, action) {
			state.isAccountDialogOpen = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addMatcher(accountsApi.endpoints.swapToken.matchFulfilled, (state, action) => {
				state.token = action.payload.token;
				storeAccessToken(action.payload.token);
			})
			.addMatcher(accountsApi.endpoints.getUserInfo.matchFulfilled, (state, action) => {
				state.user = action.payload;
			})
			.addMatcher(accountsApi.endpoints.updateCurrentAccount.matchFulfilled, (state, action) => {
				state.user = action.payload;
			})
			.addMatcher(companiesApi.endpoints.updateCurrentCompany.matchFulfilled, (state, action) => {
				if (state.user) {
					state.user.companyName = action.payload.name;
				}
			});
	},
});

export const {
	tokenSetState,
	resetState,
	isIntroDialogOpenSetState,
	isAccountDialogOpenSetState,
} = authSlice.actions;

const selectAuthSlice = (state: RootState) => state.auth;

export const selectAccessToken = createSelector([selectAuthSlice], (state: AuthState) => state.token);

export const selectUserProfile = createSelector([selectAuthSlice], (state: AuthState) => state.user);

export const selectIsAuthenticated = createSelector([selectAuthSlice], (state: AuthState) => state.user ? true : false);

export const selectIsIntroDialogOpen = createSelector([selectAuthSlice], (state: AuthState) => state.isIntroDialogOpen);

export const selectIsAccountDialogOpen = createSelector([selectAuthSlice], (state: AuthState) => state.isAccountDialogOpen);

export default authSlice.reducer;
